import React, { useEffect,useState } from 'react'

import { AxiosError } from 'axios'
import * as R from 'ramda'

import { fetchDealRooms } from 'api'
import { DealRooms } from 'components/DealRooms'
import {
  driftEmptyStateBuilder,
  driftErrorStateBuilder,
  driftLoadingStateBuilder} from 'components/States'
import { InsightOpportunity } from 'modules/accountActivity/domain'

import BaseCard from '../BaseCard'
import { CardHeader,CardHeaderExpandProps } from '../CardHeader'

import styles from './styles.module.css'

export const DealRoomCardHeader: React.FC<CardHeaderExpandProps> = ({ ...rest }) => {
  return (
    <CardHeader
      data-ocweb-id="DealRoomsCardHeader"
      content={
        <div className={styles.headerContent}>
          <div>Deal Rooms</div>
        </div>
      }
      {...rest}
    />
  )
}

interface DealRoomsCardProps {
  deal?: InsightOpportunity
}

export const DealRoomCardsContainer: React.FC<DealRoomsCardProps> = ({ deal }) => {
  const [dealRoomsData, setDealRoomsData] = useState<any>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<AxiosError>()

  const Error = driftErrorStateBuilder('Something went wrong', 'Please try again')
  const Loading = driftLoadingStateBuilder('Loading deal rooms')
  const Empty = driftEmptyStateBuilder('No deal rooms', '')
  const handleError = (err: any): void => {
    const error: AxiosError = err
    setError(error)
  }

  useEffect(() => {
    if (isLoading && deal) {
      try {
        fetchDealRooms(deal?.accountId).then(data => {
          setDealRoomsData(data)
        })
      } catch (error) {
        handleError(error)
      } finally {
        setIsLoading(false)
      }
    }
  }, [deal, isLoading])

  return (
    <BaseCard data-ocweb-id="DealRoomsContainer">
      {error && <Error />}
      {isLoading && <Loading />}
      {R.isEmpty(dealRoomsData) && <Empty />}
      {dealRoomsData && !R.isEmpty(dealRoomsData) && <DealRooms dealRoomsData={dealRoomsData} />}
    </BaseCard>
  )
}

export default DealRoomCardsContainer
